import script from "./FeedbackPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackPage.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackPage.vue?vue&type=style&index=0&id=91482dc8&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91482dc8"]])

export default __exports__